import React, { useContext, useEffect, useRef, useState } from "react";
import SingleUser from "./SingleUser";
import SingleChats from "./SingleChats";
import { io } from "socket.io-client";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import { AuthContext } from "../../../../Contexts/AuthContext/AuthProvider";
import { RotatingSquare } from "react-loader-spinner";
import { Link } from "react-router-dom";
import logo from "./../../../../logo.jpg";
import MobileOffcanvas from "./MobileOffcanvas/MobileOffcanvas";
const ENDPOINT = "https://api.wlfmobile.com";
var socket;

const LiveChats = () => {
  const { authUser } = useContext(AuthContext);
  const [data, setData] = useState([]);
  const [updateData, setUpdateData] = useState([]);
  const [singleChatData, setSingleChatData] = useState([]);
  const showRef = useRef(null);

  useEffect(() => {
    if (authUser?._id) {
      fetch(
        `https://api.wlfmobile.com/api/admin/live/chat/conversation/view/${authUser?._id}`,
        {
          method: "GET",
        }
      )
        .then((res) => res.json())
        .then((data) => {
          setData(data.data);
        });
    }
  }, [updateData]);

  useEffect(() => {
    socket = io(ENDPOINT);
  }, []);

  const [aciveUserMessage, setActiveUserMessage] = useState([]);

  const singleChatView = (Userdata) => {
    socket.emit("join_room", Userdata?.email);
    setSingleChatData(Userdata);
    showRef.current.style.display = "block";
    setActiveUserMessage(Userdata);
  };

  const ChatCloseRef = useRef();

  const HandleChatClose = (conversationId) => {
    try {
      ChatCloseRef.current.setAttribute("disabled", true);
      const config = {
        headers: {
          "content-type": "application/json",
        },
      };
      axios
        .put(
          `https://api.wlfmobile.com/api/admin/live/chat/close/chating/${conversationId}`,
          config
        )
        .then(async (res) => {
          toast.error(`Chat Closed successfully`, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
          setUpdateData(res?.data);
          showRef.current.style.display = "none";
          ChatCloseRef.current.removeAttribute("disabled");
        })
        .catch((error) => {});
    } catch (error) {}
  };

 const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);


  //   console.log(showRef.current)
  if (!authUser?.live_chat) {
    if (authUser?.live_chat === undefined) {
      return (
        <>
          <div className="loader-css">
            <RotatingSquare
              visible={true}
              height="100"
              width="100"
              color="#4fa94d"
              ariaLabel="rotating-square-loading"
              wrapperStyle={{}}
              wrapperClass=""
            />
          </div>
        </>
      );
    } else {
      return (
        <>
          <h1>unauthorized</h1>
        </>
      );
    }
  } else {
    return (
      <>
        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="colored"
        />
        <section className="live-page-area">
          <div className="live-page-header">
            <Link to="/admin/dashboard" className="sidebar__main-logo">
              <img
                src="https://res.cloudinary.com/debfkqhc8/image/upload/v1743102297/npxfpnd7fuu3t7monxwv.jpg"
                alt=""
              />
            </Link>
            <h1> WLF Mobile live Chats</h1>
          </div>
          <div className="mobile-live-page-header">
            <button onClick={handleShow}>
            <i className="fa-solid fa-bars" ></i>
            </button>
            <h2>WLF live Chats</h2>
            <Link to="/admin/dashboard" className="sidebar__main-logo">
              <img
                src="https://res.cloudinary.com/debfkqhc8/image/upload/v1743102297/npxfpnd7fuu3t7monxwv.jpg"
                alt=""
              />
            </Link>
          </div>
          <div className="shadow-lg">
            <div className="row clearfix ">
              <div className="col-lg-12">
                <div className="chat-card chat-app">
                  <div id="plist" className="people-list">
                    <ul className="list-unstyled chat-list mt-2 mb-0">
                      {data.length !== 0 ? (
                        data.map((data, index) => {
                          if (data) {
                            return (
                              <SingleUser
                                data={data}
                                index={index}
                                key={data._id}
                                singleChatView={singleChatView}
                                aciveUserMessage={aciveUserMessage}
                              ></SingleUser>
                            );
                          }
                        })
                      ) : (
                        <tr>
                          <td className="text-light text-center" colspan="100%">
                            Data not availabe
                          </td>
                        </tr>
                      )}
                    </ul>
                  </div>

                  {!aciveUserMessage?._id && (
                    <div className="chat pt-3 emtry-chats">
                      <div className="chat-header clearfix">
                        <div className="text-muted text-center fs-3">
                          At first Select user then start message
                        </div>
                      </div>
                    </div>
                  )}

                  <div
                    style={{ display: "none" }}
                    ref={showRef}
                    className="px-2 py-3"
                  >
                    <SingleChats
                      singleChatData={singleChatData}
                      HandleChatClose={HandleChatClose}
                      ChatCloseRef={ChatCloseRef}
                    ></SingleChats>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <MobileOffcanvas  show={show} handleClose={handleClose} data={data} singleChatView={singleChatView} aciveUserMessage={aciveUserMessage} />
      </>
    );
  }
};

export default LiveChats;
